var getIdFromIri = function (iri) {
    var parts = iri.split('/');
    if (parts.length === 0) {
        return iri;
    }
    return parts[parts.length - 1];
};
export default getIdFromIri;
